import React, { Fragment } from 'react'
import Clusters from './Clusters'
import StreetViewMarker from './StreetViewMarker'
import InfoBox from './InfoBox'
import SameSupportInfoBox from './SameSupportInfoBox'
import SameLocationInfoBox from './SameLocationInfobox'
import SearchMarker from './SearchMarker'
import SignCounts from './SignCounts'
import WatchPos from './WatchPos'

const Markers = () => (
  <Fragment>
    <Clusters />
    <StreetViewMarker />
    <SignCounts />
    <InfoBox />
    <SameSupportInfoBox />
    <SameLocationInfoBox />
    <WatchPos />
    <SearchMarker />
  </Fragment>
)

export default Markers



// WEBPACK FOOTER //
// ./src/components/Map/Markers/index.jsx